import { SimpleMuiButton } from '@dreamstack/feature-components/src/layout/SimpleMuiButton'
import { useTranslation } from '@dreamstack/i18n'
import filter from 'lodash/filter'
import includes from 'lodash/includes'
import map from 'lodash/map'
import some from 'lodash/some'
import type { FunctionComponent } from 'react'
import React from 'react'

const getTrackingId = (controlValue: string | number) => {
  const controlValueEncoded = encodeURIComponent(controlValue)
  const trackingId = `ga-home-ownership-report-graph-control-${controlValueEncoded}`
  return trackingId
}

export const GraphControls: FunctionComponent<
  React.PropsWithChildren<{
    possibleValues?: (string | number)[]
    setArray: (value: React.SetStateAction<any[]>) => void
    selectedValues: any[]
    graphControlAllLabel?: string
  }>
> = ({ possibleValues, setArray, selectedValues, graphControlAllLabel }) => {
  const allItemsSelected = possibleValues
    ? possibleValues.length === selectedValues.length
    : true
  const variant = allItemsSelected ? 'contained' : 'outlined'
  const t = useTranslation()
  return (
    <div className="flex flex-wrap lg:justify-center">
      <div className="p-px-6 md:p-px-12 inline">
        <SimpleMuiButton
          onClick={() =>
            setArray(() => {
              if (allItemsSelected) {
                return []
              } else {
                // if allItemsSelected is false, possibleValues is set
                return possibleValues!
              }
            })
          }
          variant={variant}
          style={{ fontWeight: !allItemsSelected ? 600 : 400 }}
          size="small"
          className={getTrackingId('all')}
        >
          {graphControlAllLabel || t('accentro:graphControls.selectAll')}
        </SimpleMuiButton>
      </div>
      {map(
        filter(possibleValues, (value) => includes(possibleValues, value)),
        (x, i) => {
          const selected = selectedValues.includes(x)
          const variant = selected ? 'contained' : 'outlined'
          return (
            <div className="p-px-6 md:p-px-12 inline" key={i}>
              <SimpleMuiButton
                onClick={() =>
                  setArray((old) => {
                    const entry = some(old, (o) => o === x)
                    const selected = !!entry ? false : true
                    if (selected) {
                      return old.concat(x)
                    } else {
                      const newState = filter(old, (o) => o !== x)
                      return newState
                    }
                  })
                }
                variant={variant}
                style={{ fontWeight: !selected ? 600 : 400 }}
                size="small"
                className={getTrackingId(x)}
              >
                {x}
              </SimpleMuiButton>
            </div>
          )
        }
      )}
    </div>
  )
}
